import Vue from 'vue'
import App from './App.vue'
import vueSwiper from 'vue-awesome-swiper'
import "../node_modules/swiper/css/swiper.css"
import "./styles/reset.css"
import "./styles/style.css"
import 'animate.css';
import VueRouter from "vue-router";
import Index from './views/index'
// import NotFound from './views/notFound'
import About_us from './views/about_us'
import Education from './views/education'
import Out_source from './views/out_source'
import Maker from './views/maker.vue'
import Login from './views/login.vue'
import Register from './views/register.vue'
import Find_pwd from './views/find_pwd.vue'
import News from './views/news.vue'
import News_detail from './views/news_detail.vue'
import Market from './views/market.vue'
import MakerInfo from './views/makerInfo.vue'
import EnterpriserInfo from './views/enterpriserInfo.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "../public/js/iframe/iframeResizer.min.js";

import axios from 'axios'
import VueAxios from 'vue-axios'




const routes = [
  { path: '/', component: Index },
  { path: '/about_us', component: About_us },
  { path: '/education', component: Education },
  { path: '/out_source', component: Out_source },
  { path: '/maker', component: Maker },
  { path: '/login', component: Login },
  { path: '/register', component: Register },
  { path: '/find_pwd', component: Find_pwd },
  { path: '/news', component: News },
  { path: '/news_detail', component: News_detail },
  { path: '/market', component: Market },
  { path: '/maker_info', component: MakerInfo },
  { path: '/enterprise_info', component: EnterpriserInfo },
]
const router = new VueRouter({
  mode: 'history',
  base: '/website/',
  routes
})
Vue.prototype.$axios = axios
Vue.prototype.$url = 'https://www.lgbfss.com'
Vue.config.productionTip = false
Vue.use(vueSwiper)
Vue.use(VueAxios, axios)
Vue.use(ElementUI);
Vue.use(VueRouter)
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

// document.body.style.zoom = document.body.clientWidth / 1920;
